import React, { createContext, useContext, useState, useEffect } from 'react';
import { validateSession } from '../../lib/api';
import { User } from '../../lib/types';

interface AuthContextType {
    isAuthenticated: boolean;
    checkAuth: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    const checkAuth = async () => {
        const userString = localStorage.getItem("user");
        let validSession = false;
        let userEmail = "";

        try{
            const user: User = JSON.parse(userString || ""); 
            userEmail = user.user_email;
            
        } catch(error){
            console.log("No user found")
        }
        try {
            const validateUserSessionResp = await validateSession(userEmail);

            validSession = validateUserSessionResp.status === "valid";
        } catch(error) {
            console.log("Invalid session: ", error)
            setIsAuthenticated(false);
            return;
        }
            
        const cookie = document.cookie.split('; ').find(row => row.startsWith('admin_access_token='));
        setIsAuthenticated(validSession || !!cookie);
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};